export const colorArray = [
  'warning.main',
  'success.main',
  'info.main',
  'primary.main',
  'error.main',
]
